import { Injectable } from '@angular/core';
import { RootScopeService } from './root-scope.service';
import { NewAgentApiService } from './new-agent-api.service';
import { Global } from '../global/globalApi';
import * as Constants from '../models/Constants';
import { AuthMethodService } from './auth-method.service';

@Injectable({
  providedIn: 'root'
})
export class ClearIdentityService {
  public fileName = "ClearIdentityService";

  public clearMsg: string = '';
  constructor(public rootScope: RootScopeService, public agentService: NewAgentApiService, public authService: AuthMethodService) {

  }



  clearInfoMessage() {
    const activeTab = this.rootScope.activeCustTab;
    let status = true;

    if (!activeTab.clearIdentityData.isClearIdentityEnabled) {
      this.clearMsg = Constants.CLEAR_IDENTITY.invalidClient;
      status = false;
    }
    else if (!this.rootScope.isLiveCall) {
      this.clearMsg = Constants.PEA_MESSAGES.AVAILABLE_DURING_LIVE_INTERACTION;
      status = false;
    }
    else if (activeTab.CS_SECURITY_LEVEL == Constants.securityLevels.SL4) {
      this.clearMsg = Constants.AUTH_IND_FULLY_SECURED;
      status = false;
    }
    else if (!this.authService.CustTypeConfigCheck(Constants.AuthMenu.IDENTITY_VERIFICATION)) {
      this.clearMsg = Constants.AuthMethods.IDENTITY_VERIFICATION + " " + Constants.NOT_CONFIGURED_CUSTTYPE;
      status = false;
    }
    else this.clearMsg = '';

    return status;
  }

  clearCheckEligibility(event: any) {
    const payload = (event as CustomEvent<{
      uuid: string;
      checked: boolean;
      value: string;
    }>).detail;

    const activeTab = this.rootScope.activeCustTab;
    activeTab.clearIdentityData.Step1CheckList = activeTab.clearIdentityData.Step1CheckList.map((item) =>
      item.uuid == payload.uuid ? { ...item, checked: payload.checked } : item
    );


    activeTab.clearIdentityData.StartADIV = activeTab.clearIdentityData.Step1CheckList.every((item: any) => item.checked);
  }


  public clearStepsClass(step: string): string {
    
    const clearIdentityData = this.rootScope.activeCustTab.clearIdentityData;

    switch (step) {
      case '1':
        if (clearIdentityData.step1Active) {
          return !clearIdentityData.step1Complete ? 'active' : 'complete';
        }
        break;
      case '2':
        if (clearIdentityData.step2Active) {
          return !clearIdentityData.step2Complete ? 'active' : 'complete';
        }
        break;
      case '3':
        if (clearIdentityData.step3Active) {
          return !clearIdentityData.step3Complete ? 'active' : 'complete';
        }
        break;
    }
    return '';
  }


}
